// extracted by mini-css-extract-plugin
export default {"excelBtn":"ClientsDebetors_excelBtn__k+mgE","list":"ClientsDebetors_list__K7er+","listHeader":"ClientsDebetors_listHeader__0UNAN","pagination":"ClientsDebetors_pagination__+e28e"};